import React, { useEffect, useState } from "react";
import { Dropdown, DropdownButton } from "react-bootstrap";

const categoryType = ["Beds", "Baths"];
var noOfBhkOption = ["Studio", "1", "2", "3", "4", "5", "6", "7", "8", "9", "10"];
var bathOption = ["1", "2", "3", "4", "5", "6", "7"];

export default function DropdownMulti({ name, bannerFilter, filterCallBack, filterReset }) {
    const [selectOptions, setSelectOptions] = useState({ bedRooms: [], baths: [] });
    const [dataoptions, setDataOption] = useState(bannerFilter);

    useEffect(() => {
        setDataOption(bannerFilter);
        setSelectOptions(bannerFilter);
    }, [bannerFilter]);

    const toggleSelection = (category, value) => {
        setSelectOptions((prevState) => {
            const current = prevState[category];
            const isSelected = current.includes(value);
            let updated = isSelected ? current.filter((item) => item !== value) : [...current, value];
            if (category === "bedRooms") {
                const studio = updated.includes("Studio") ? ["Studio"] : [];
                const elevenPlus = updated.includes("11 +") ? ["11 +"] : [];
                const numeric = updated
                    .filter((item) => item !== "Studio" && item !== "11 +")
                    .map(Number)
                    .sort((a, b) => a - b)
                    .map(String);
                updated = [...studio, ...numeric, ...elevenPlus];
            }
            if (category === "baths") {
                updated = updated
                    .map((item) => (item === "8+" ? "8.5" : item))
                    .map(Number)
                    .sort((a, b) => a - b)
                    .map((n) => (n === 8.5 ? "8+" : String(n)));
            }
            let option = dataoptions;
            if (updated) option[category] = updated;
            else option[category] = "";
            setDataOption(option);
            filterCallBack(option);
            // if (updated && updated.length == 0) filterReset();
            return {
                ...prevState,
                [category]: updated,
            };
        });
    };

    const isSelected = (category, value) => selectOptions[category]?.includes(value);

    const handleReset = () => {
        let option = selectOptions;
        option["bedRooms"] = [];
        option["baths"] = [];
        setSelectOptions(option);
        filterCallBack(option);
        // filterReset();
    };

    const formatTitle = () => {
        let option = selectOptions;
        const beds = option["bedRooms"];
        const baths = option["baths"];
        const bedsLabel = beds && beds.length > 0 ? `${beds.join(", ")} ${beds.length === 1 && beds[0] === "Studio" ? "" : beds.length === 1 && beds[0] === "1" ? "bed" : "beds"}` : "";
        const bathsLabel = baths && baths.length > 0 ? `${baths.join(", ")} ${baths.length === 1 && baths[0] === "1" ? "bath" : "baths"}` : "";
        if (bedsLabel && bathsLabel) return `${bedsLabel} / ${bathsLabel}`;
        return bedsLabel || bathsLabel || name;
    };

    return (
        <div className="filter-dropdown">
            <DropdownButton className="custom-dropdown" title={formatTitle()}>
                <ul className="dropdown_tlt">
                    <li>{categoryType[0]}</li>
                </ul>
                <div className="grid_columns dropdown-grid">
                    {noOfBhkOption.map((item, i) => (
                        <Dropdown.Item
                            as="span"
                            key={i}
                            className={isSelected("bedRooms", item) ? "active" : ""}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleSelection("bedRooms", item);
                            }}
                        >
                            {item}
                        </Dropdown.Item>
                    ))}
                </div>
                <ul className="dropdown_tlt">
                    <li>{categoryType[1]}</li>
                </ul>
                <div className="grid_columns dropdown-grid">
                    {bathOption.map((item, i) => (
                        <Dropdown.Item
                            as="span"
                            key={i}
                            className={isSelected("baths", item) ? "active" : ""}
                            onClick={(e) => {
                                e.stopPropagation();
                                toggleSelection("baths", item);
                            }}
                        >
                            {item}
                        </Dropdown.Item>
                    ))}
                </div>
                {selectOptions.baths?.length > 0 || selectOptions.bedRooms.length > 0 ? (
                    <Dropdown.Item as="span" className="full-width">
                        <button className="reset-button" onClick={handleReset}>
                            Reset
                        </button>
                        <button className="done-button">Done</button>
                    </Dropdown.Item>
                ) : (
                    <></>
                )}
            </DropdownButton>
        </div>
    );
}
